import aiAssistantAvatarUrl from '../../assets/assistant-button.svg';

export const AI_ASSISTANT_AVATAR_URL = aiAssistantAvatarUrl;
